import React from 'react';
import { Shield, Briefcase } from 'lucide-react';

interface LoginHeaderProps {
  isAdminLogin: boolean;
}

export const LoginHeader: React.FC<LoginHeaderProps> = ({ isAdminLogin }) => {
  return (
    <div className="text-center">
      <div className="w-16 h-16 bg-purple-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
        {isAdminLogin ? (
          <Shield className="w-8 h-8 text-purple-300" />
        ) : (
          <Briefcase className="w-8 h-8 text-purple-300" />
        )}
      </div>
      <h2 className="text-2xl font-bold text-purple-200">
        {isAdminLogin ? 'Portal Administrativo' : 'Portal do Membro'}
      </h2>
      <p className="mt-2 text-purple-200/70">
        {isAdminLogin 
          ? 'Acesso restrito para administradores'
          : 'Acesso exclusivo para membros certificados'
        }
      </p>
    </div>
  );
};